import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import moment from "moment";

const { getWiFiBatchReports } = reportActions;
const dateFormat = process.env.REACT_APP_DATE_TIME_FORMAT;


const WIFIBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [searchItem, setSearchItem] = useState("");
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const { wifiBatchReports, wifiBatchReportsLoading, } = useSelector((state) => state.reports)

    const {  formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getWiFiBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);


    const columns = [
        { displayName: "Batch ID", key: "BatchId" },
        { displayName: "Transaction ID", key: "TransactionId" },
        { displayName: "Serial Number", key: "SerialNumber" },
        { displayName: "MSISDN", key: "MobileNumber" },
        { displayName: "Street1", key: "Street1" },
        { displayName: "Street2", key: "Street2" },
        { displayName: "City", key: "City" },
        { displayName: "State", key: "State" },
        { displayName: "Zip", key: "Zip" },
        { displayName: "Status", key: "Status" },
        { displayName: "Created On", key: "CreatedOn" },
        { displayName: "Updated On", key: "UpdatedOn" },
        { displayName: "Remarks", key: "Remarks" },

    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(wifiBatchReports) && wifiBatchReports.length > 0
            ? wifiBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [wifiBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            "BatchId": item["BatchID"],
            "TransactionId": item["TransactionID"],
            "SerialNumber": item["Iccid"],
            "MobileNumber": item["Msisdn"],
            "Street1": item["Street1"],
            "Street2": item["Street2"],
            "City": item["City"],
            "State": item["State"],
            "Zip": item["Zip"],
            "Status": item["Status"],
            "CreatedOn": moment(item?.CreatedOn).format(dateFormat),
            "UpdatedOn": moment(item?.UpdatedOn).format(dateFormat),
            "Remarks": item["Remarks"],

        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            "Batch ID": item["BatchID"],
            "Transaction ID": item["TransactionID"],
            "Serial Number": item["Iccid"],
            "MSISDN": item["Msisdn"],
            "Street1": item["Street1"],
            "Street2": item["Street2"],
            "City": item["City"],
            "State": item["State"],
            "Zip": item["Zip"],
            "Status": item["Status"],
            "Created On": moment(item?.CreatedOn).format(dateFormat),
            "Updated On": moment(item?.UpdatedOn).format(dateFormat),
            "Remarks": item["Remarks"],
        }));

        downloadExcelSampleFile(data, "Wi-Fi-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Wi-Fi Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex flex-wrap align-items-center gap-1">
                    <input
                        type="search"
                        style={{ width: "300px", }}
                        onChange={(e) => setSearchItem(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="Search..." />
                    <Button
                        title="Back"
                        buttonType="button"
                        icon={<i className="ri-arrow-left-line me-1" />}
                        variant="primary"
                        style={{
                            padding: "5px 10px",
                        }}
                        onClick={() => handleBack()}
                    />
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />
                </div>
            }
        >
            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={wifiBatchReportsLoading}
                    tableHeight="270px"
                />
            </div>


        </CardLayout>

    );
};

export default WIFIBatchDetails;

